"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var onlineResourceManager = new q_play_core_1.OnlineResourceManager();
var IdpGroupMatchModal = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(props.IdpGroupMatch ? props.IdpGroupMatch.group_id : ""), groupId = _a[0], setGroupId = _a[1];
    var _b = (0, react_1.useState)(props.IdpGroupMatch ? props.IdpGroupMatch.qteam_id : ""), qteamId = _b[0], setQteamId = _b[1];
    var createIdpGroupMatch = function () {
        var payload = {
            qteam_id: qteamId,
            group_id: groupId,
        };
        var request = onlineResourceManager.makeJSONRequest("/api/idp/group-map", "POST", JSON.stringify(payload));
        request.getResponseData().then(function () {
            props.updateIDPGroupMap();
            props.toggle();
        });
    };
    var updateIdpGroupMatch = function () {
        if (!props.IdpGroupMatch)
            return;
        var payload = {
            qteam_id: qteamId,
            group_id: groupId,
        };
        var request = onlineResourceManager.makeJSONRequest("/api/idp/group-map/" + props.IdpGroupMatch.id, "PUT", JSON.stringify(payload));
        request.getResponseData().then(function () {
            props.updateIDPGroupMap();
            props.toggle();
        });
    };
    (0, react_1.useEffect)(function () {
        if (props.isShown === true) {
            setGroupId(props.IdpGroupMatch ? props.IdpGroupMatch.group_id : "");
            setQteamId(props.IdpGroupMatch ? props.IdpGroupMatch.qteam_id : props.qteams[0].id);
        }
    }, [props.isShown]);
    var body = (react_1.default.createElement("div", { className: "d-flex flex-column", style: { gap: "5px" } },
        react_1.default.createElement("span", null,
            t("IDP Group ID"),
            ":"),
        react_1.default.createElement(q_play_components_1.Input, { className: "mt-1 block w-full", value: groupId, onChange: function (event) { setGroupId(event.target.value); } }),
        react_1.default.createElement("span", null, "Qteam:"),
        react_1.default.createElement(q_play_components_1.Select, { onChange: function (event) { setQteamId(event.target.value); }, value: qteamId }, props.qteams.map(function (qteam) { return (react_1.default.createElement("option", { key: qteam.id, value: qteam.id }, qteam.name)); }))));
    var createFooter = (react_1.default.createElement("div", { style: { marginTop: "1rem", display: "flex", justifyContent: "center", width: "100%" } },
        react_1.default.createElement(q_play_components_1.Button, { onClick: createIdpGroupMatch, variant: "primary", text: t("Create"), size: "small", className: "w-50" })));
    var updateFooter = (react_1.default.createElement("div", { style: { marginTop: "1rem", display: "flex", justifyContent: "center", width: "100%" } },
        react_1.default.createElement(q_play_components_1.Button, { onClick: updateIdpGroupMatch, variant: "primary", text: t("Save"), size: "small", className: "w-50" })));
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: props.isShown, centered: true, onClose: props.toggle, headerText: props.IdpGroupMatch ? t("Edit IDP Group match") : t("Create IDP Group match"), body: body, footer: props.IdpGroupMatch ? updateFooter : createFooter }));
};
exports.default = IdpGroupMatchModal;
